export default __webpack_public_path__ + "static/media/captchaBG.247462b5.svg";